import React from 'react'
import Modal from '../../../components/Modal'
import { formatMoney } from '../utils/formatMoney'

export function DayDetailsModal({ selectedDayDetails, setSelectedDayDetails, groupedOps, isAdmin, profile }) {
  return (
    <Modal isOpen={!!selectedDayDetails} onClose={() => setSelectedDayDetails(null)} title={`Детализация показателей за ${selectedDayDetails?.displayDate || ''}`}>
      {selectedDayDetails && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          {/* Операции за день */}
          <div style={{ background: 'var(--bg-secondary)', padding: '16px', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
            <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', color: 'var(--text-primary)', borderBottom: '1px solid var(--surface-border)', paddingBottom: '6px' }}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg> Физические операции
            </h4>
            {groupedOps.length === 0 ? (
              <div style={{ color: 'var(--text-tertiary)', fontSize: '13px' }}>Нет зарегистрированных операций за этот день.</div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {groupedOps.map((op, idx) => (
                  <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                    <span style={{ color: 'var(--text-secondary)' }}>{op.name}</span>
                    <span style={{ fontWeight: 600 }}>{op.value} шт.</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {/* Финансы за день — полные для Владельца, только Расходы для Администраторов */}
          {isAdmin && (
            profile?.role === 'owner' ? (
              <div style={{ background: 'var(--bg-secondary)', padding: '16px', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', color: 'var(--text-primary)', borderBottom: '1px solid var(--surface-border)', paddingBottom: '6px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> Финансовые транзакции
                </h4>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', textTransform: 'uppercase' }}>Доходы</div>
                    <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--success)' }}>{formatMoney(selectedDayDetails.income)}</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', textTransform: 'uppercase' }}>Расходы</div>
                    <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--danger)' }}>-{formatMoney(selectedDayDetails.expense)}</div>
                  </div>
                </div>
                
                <div style={{ borderTop: '1px solid var(--surface-border)', paddingTop: '12px', marginBottom: '16px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', textTransform: 'uppercase' }}>Результат (Прибыль)</div>
                  <div style={{ fontSize: '20px', fontWeight: '800', color: selectedDayDetails.realProfit < 0 ? 'var(--danger)' : 'var(--wb-primary)' }}>
                    {formatMoney(selectedDayDetails.realProfit)}
                  </div>
                </div>
                
                {/* Расшифровка доходов */}
                {selectedDayDetails.details.incomes.length > 0 && (
                  <div style={{ marginBottom: '12px' }}>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--success)', marginBottom: '6px' }}>Поступления:</div>
                    {selectedDayDetails.details.incomes.map((i, idx) => (
                      <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', paddingLeft: '8px', borderLeft: '2px solid var(--success)', marginBottom: '4px' }}>
                        <span style={{ color: 'var(--text-secondary)' }}>{i.name}</span>
                        <span style={{ fontWeight: 500 }}>{formatMoney(i.amount)}</span>
                      </div>
                    ))}
                  </div>
                )}
                
                {/* Расшифровка расходов */}
                {selectedDayDetails.details.expenses.length > 0 && (
                  <div>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--danger)', marginBottom: '6px' }}>Затраты:</div>
                    {selectedDayDetails.details.expenses.map((e, idx) => (
                      <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', paddingLeft: '8px', borderLeft: '2px solid var(--danger)', marginBottom: '4px' }}>
                        <span style={{ color: 'var(--text-secondary)' }}>{e.name}</span>
                        <span style={{ fontWeight: 500 }}>{formatMoney(e.amount)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              // Для администратора показываем только расходы
              <div style={{ background: 'var(--bg-secondary)', padding: '16px', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', color: 'var(--text-primary)', borderBottom: '1px solid var(--surface-border)', paddingBottom: '6px' }}>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> Затраты за день
                </h4>
                
                <div style={{ marginBottom: '16px' }}>
                  <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', textTransform: 'uppercase' }}>Всего расходов</div>
                  <div style={{ fontSize: '18px', fontWeight: '700', color: 'var(--danger)' }}>-{formatMoney(selectedDayDetails.expense)}</div>
                </div>
                
                {/* Расшифровка расходов */}
                {selectedDayDetails.details.expenses.length > 0 && (
                  <div>
                    <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--danger)', marginBottom: '6px' }}>Детализация затрат:</div>
                    {selectedDayDetails.details.expenses.map((e, idx) => (
                      <div key={idx} style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', paddingLeft: '8px', borderLeft: '2px solid var(--danger)', marginBottom: '4px' }}>
                        <span style={{ color: 'var(--text-secondary)' }}>{e.name}</span>
                        <span style={{ fontWeight: 500 }}>{formatMoney(e.amount)}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )
          )}
          
          <button className="btn btn-secondary w-full" onClick={() => setSelectedDayDetails(null)}>Закрыть</button>
        </div>
      )}
    </Modal>
  )
}
